/**
 * The node popup's fold keys (V0.51) — the strings that end up in `ViewRecord.openSections`.
 *
 * A module of its own, with no imports, for one reason: `revealTodo()` in `app/actions.ts` has
 * to open the To-dos fold, and `PopupFold` has to call `setSectionOpen` — so a key declared in
 * either one would make the other's import a cycle. Seven constants and nothing else cannot.
 *
 * NOT A REGISTRY. Nothing iterates this, and `setSectionOpen()` deliberately validates nothing
 * against it: an unknown key is a section this build no longer draws, and it costs nothing to
 * carry until the day-scoped record ages out at 04:00. What this file buys is that each key is
 * written down ONCE — the V0.50 pair (`'todos'` in `TodoSection.tsx` and the same literal in
 * `actions.ts`) is exactly the drift it prevents.
 *
 * The `popup:` prefix is not decoration: `collapsedSections` holds the "My items" pane's
 * headings under bare keys, and these two lists have opposite defaults (see
 * `ViewRecord.openSections`). A prefix means a key read from storage says which list it came
 * from even when somebody is looking at it out of context.
 */
export const SECTION_RESPONSIBLES = 'popup:responsibles';
export const SECTION_DOCS = 'popup:docs';
export const SECTION_TAGS = 'popup:tags';
export const SECTION_TODOS = 'popup:todos';
export const SECTION_AI = 'popup:ai';
export const SECTION_AI_GROUNDING = 'popup:ai-grounding';
export const SECTION_AI_LIVE = 'popup:ai-live';
